/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Standard_CommitmentInputs */

const et_plan_standard_commitment = /** @type {(inputs: Plan_Standard_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 kuu kohustus. Seejärel igakuiselt tühistatav.`)
};

const en_plan_standard_commitment = /** @type {(inputs: Plan_Standard_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3-month commitment. Then cancellable monthly.`)
};

/**
* | output |
* | --- |
* | "3-month commitment. Then cancellable monthly." |
*
* @param {Plan_Standard_CommitmentInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_standard_commitment = /** @type {((inputs?: Plan_Standard_CommitmentInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Standard_CommitmentInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_standard_commitment(inputs)
	return en_plan_standard_commitment(inputs)
});